import { Grid, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import permissions from "app/permissions";
import React, { useCallback, useEffect, useState } from "react";
import { Labeled, ReferenceField, SimpleShowLayout, TextField } from "react-admin";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import { activityRequests } from "api/activityApi";
import UpdateForeignLanguageScheduleDialog from "./UpdateForeignLanguageScheduleDialog";

const ForeignLanguagesActivitiesData = ({ educationId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [foreignLanguageActivities, setForeignLanguageActivities] = useState({});

  const fetchForeignLanguageActivities = useCallback(async () => {
    if (!educationId) return;
    try {
      const { data } = await dataProvider.customRequest(
        activityRequests.studentForeignLanguageSchedule(educationId),
        null,
        "GET",
      );
      setForeignLanguageActivities(data || {});
    } catch (err) {
      setForeignLanguageActivities({});
      console.error(err.message);
    }
  }, [educationId]);

  useEffect(() => {
    fetchForeignLanguageActivities();
  }, [fetchForeignLanguageActivities]);

  const isForeignLanguageData = Object.keys(foreignLanguageActivities).length > 0;

  return (
    <SimpleShowLayout record={foreignLanguageActivities}>
      <Grid
        container
        spacing={isForeignLanguageData ? 3 : 0}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {!isForeignLanguageData ? (
          <Typography sx={{ fontWeight: 400, fontSize: "14px", mt: 2, ml: 2, mb: 3 }}>
            Няма намерени резултати
          </Typography>
        ) : (
          <>
            <Grid
              item
              xs={2}
            >
              <Labeled label="Език">
                <TextField source="foreignLanguageNameBg" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={2}
            >
              <Labeled label="Ниво на език">
                <ReferenceField
                  source="foreignLanguageLevel"
                  reference={activityRequests.getActivityForeignLanguagesLevelsSelect()}
                >
                  <TextField source="name" />
                </ReferenceField>
              </Labeled>
            </Grid>
          </>
        )}
        <Grid
          item
          xs={12}
          sx={{ ml: !isForeignLanguageData ? 2 : 0 }}
        >
          <SecuredComponent permission={permissions.canManageStudentsForeignLanguages}>
            <UpdateForeignLanguageScheduleDialog
              educationId={educationId}
              // foreignLanguageId={foreignLanguageActivities?.foreignLanguageId}
              fetchForeignLanguageActivities={fetchForeignLanguageActivities}
              foreignLanguageActivities={isForeignLanguageData ? foreignLanguageActivities : null}
            />
          </SecuredComponent>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default ForeignLanguagesActivitiesData;
